import { createApp } from 'vue'
import App from './views/Study.vue'
import BasketIcon from './views/BasketIcon.vue'
import router from './router'
import store from './store'

createApp(BasketIcon).use(store).use(router).mount('.cartIcon')
let app_class = window.front_page ? '.front-study-page' : '.study-page';
createApp(App).use(store).use(router).mount(app_class)
